<template>
    <Toast />
    <form @submit.prevent="submit()">
        <div class="p-d-flex p-jc-between">
            <p class="title">Account Management</p>
            <div>
            
                <Button label="Add" class="button btn" type="submit"  :loading="loading"
                :disabled="loading" />
            </div>
        </div>

        <div class="card">

            <h4>Add Channel</h4>

            <!-- Channel Form -->
            <div class="p-grid p-fluid">
                <!-- Basic Channel Information -->
                <div class="p-col-12 p-md-6">
                    <p class="field-title">Name</p>
                    <InputText 
                        type="text" 
                        v-model="v$.Name.$model" 
                        placeholder="Channel name"
                    ></InputText>
                    <p v-for="error of v$.Name.$errors" :key="error.$uid" class="error-msg">
                        {{ 'Please enter the channel name' }}
                    </p>
                </div>
                <div class="p-col-12 p-md-6">
                    <p class="field-title">Account code</p>
                    <InputText type="text" v-model="v$.accountCode.$model" placeholder="Account code"></InputText>
                    <p v-for="error of v$.accountCode.$errors" :key="error.$uid" class="error-msg">
                        {{ 'Please enter the account code' }}
                    </p>
                </div>
                <div v-if="platformName === 'ArenaCX'" class="p-col-12 p-md-6">
                    <p class="field-title">ArenaCX Quickbooks ID</p>
                    <InputText type="number" min="0" v-model="v$.quickbooksID.$model" placeholder="ArenaCX Quickbooks ID" @keypress="validateNumberInput">
                    </InputText>
                    <p v-for="error of v$.quickbooksID.$errors" :key="error.$uid" class="error-msg">
                        {{ error.$validator === 'required' ? 'Please enter the ArenaCX Quickbooks ID' : 
                           error.$validator === 'numeric' ? 'Only numbers are allowed' : 
                           'Please enter the ArenaCX Quickbooks ID' }}
                    </p>
                </div>
                <div class="p-col-12 p-md-6">
                    <p class="field-title">Description</p>
                    <InputText type="text" v-model="v$.description.$model" placeholder="Description"></InputText>
                    <p v-for="error of v$.description.$errors" :key="error.$uid" class="error-msg">
                        {{ 'Please enter the description' }}
                    </p>
                </div>

                <!-- Admin Information -->
                <div class="p-col-12 p-md-6">
                    <p class="field-title">Admin First Name</p>
                    <InputText type="text" v-model="v$.adminFirstName.$model" placeholder="Admin first name">
                    </InputText>
                    <p v-for="error of v$.adminFirstName.$errors" :key="error.$uid" class="error-msg">
                        {{ 'Please enter the admin first name' }}
                    </p>
                </div>

                <div class="p-col-12 p-md-6">
                    <p class="field-title">Admin Last Name</p>
                    <InputText type="text" v-model="v$.adminLastName.$model" placeholder="Admin last name"></InputText>
                    <p v-for="error of v$.adminLastName.$errors" :key="error.$uid" class="error-msg">
                        {{ 'Please enter the admin last name' }}
                    </p>
                </div>

                <div class="p-col-12 p-md-6">
                    <p class="field-title">Admin Email</p>
                    <InputText type="text" v-model="v$.adminEmail.$model" placeholder="Admin email"></InputText>
                    <p v-for="error of v$.adminEmail.$errors" :key="error.$uid" class="error-msg">
                        {{ error.$validator === 'required' ? 'Please enter the admin email' : 
                           error.$validator === 'email' ? 'Please enter a valid email address' : 
                           'Please enter the admin email' }}
                    </p>
                </div>

                <!-- Phone Number -->
                <div class="p-col-12 p-md-6">
                    <p class="field-title">Admin Phone Number</p>
                    <InputText type="text" v-model="phoneNumber" placeholder="Enter phone number"></InputText>
                    <p v-for="error of v$.phoneNumber.$errors" :key="error.$uid" class="error-msg">
                        {{ error.$validator === 'required' ? 'Please enter the admin phone number' :
                            error.$validator === 'format' ? 'Please enter a valid phone number (e.g. (123) 123-1234, 123 - 123 - 1234, +1 415 555 2671) ' :
                                'Please enter the admin phone number' }}
                    </p>
                </div>

                <!-- Title -->
                <div class="p-col-12 p-md-6">
                    <p class="field-title">Admin Title</p>
                    <InputText type="text" v-model="title" placeholder="Enter title"></InputText>
                    <p v-for="error of v$.title.$errors" :key="error.$uid" class="error-msg">
                        {{ 'Please enter the admin title' }}
                    </p>
                </div>

                <!-- Company Name -->
                <div class="p-col-12 p-md-6">
                    <p class="field-title">Company Name</p>
                    <InputText type="text" v-model="companyName" placeholder="Enter company name"></InputText>
                    <p v-for="error of v$.companyName.$errors" :key="error.$uid" class="error-msg">
                        {{ 'Please enter the company name' }}
                    </p>
                </div>

                <!-- Company Website URL -->
                <div class="p-col-12 p-md-6">
                    <p class="field-title">Company Website URL</p>
                    <InputText type="text" v-model="companyWebsiteUrl" placeholder="Enter company website URL">
                    </InputText>
                    <p v-for="error of v$.companyWebsiteUrl.$errors" :key="error.$uid" class="error-msg">
                        {{ error.$validator === 'required' ? 'Please enter the company website URL' : 'Please enter a valid website URL' }}
                    </p>
                </div>

                <!-- Industry Dropdown -->
                <div class="p-col-12 p-md-6">
                    <p class="field-title">Industry</p>
                    <Dropdown id="industry" v-model="selectedIndustry" filter :options="industryOptions"
                        optionLabel="label" optionValue="value" optionGroupLabel="label" optionGroupChildren="items"
                        aria-describedby="industry-help"
                        :class="{ 'p-invalid': v$.selectedIndustry.$invalid && submitted }" placeholder="Industry"
                        @change="handleDropdownChange">
                        <template #optiongroup="slotProps">
                            <div class="industry-heading">
                                <div class="industryOptionHeader">
                                    {{ slotProps.option.label }}
                                </div>
                                <hr class="industry-underline" />
                            </div>
                        </template>

                        <template #option="slotprops">
                            <div class="industryOption">{{ slotprops.option.label }}</div>
                        </template>
                    </Dropdown>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import AccountMangementService from '../../service/AccountManagementService';
import UserManagementService from '../../service/Usermanagement';
import IndustryService from '../../service/IndustryService';
import optionsService from '../../service/AnswerOptionsService';
import { required, minLength } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { Dropdown } from 'primevue/dropdown';
import EventBus from '../../event-bus'
import { USER_ROLE_IDS } from '../../utilities/constants';

export default {
    components: {
        Dropdown,
    },
    data() {
        return {
            accountMangementService: new AccountMangementService(),
            userManagementService: new UserManagementService(),
            industryService: new IndustryService(),
            optionsService: new optionsService(),
            userDetails: null,
            Name: '',
            accountCode: '',
            quickbooksID: '',
            description: '',
            adminFirstName: '',
            adminLastName: '',
            adminEmail: '',
            loading: false,
            phoneNumber: '',
            title: '',
            companyName: '',
            companyWebsiteUrl: '',
            industryOptions: [],
            selectedIndustry: null,
            submitted: false,
            platformName: process.env.VUE_APP_PLATFORM_NAME
        };
    },
    validations() {
        return {
            Name: { required, minLength: minLength(1) },
            accountCode: { required, minLength: minLength(1) },
            quickbooksID: {
                minLength: minLength(1),
                numeric: (value) => {
                    if (!value) return true; // Let required validation handle empty values
                    return /^\d+$/.test(value.toString());
                }
            },
            description: { required, minLength: minLength(1) },
            adminFirstName: { required, minLength: minLength(1) },
            adminLastName: { required, minLength: minLength(1) },
            adminEmail: {
                required,
                minLength: minLength(1),
                email: (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
            },
            phoneNumber: {
                required,
                format: (value) => {
                    if (!value) return true;
                    // Allow formats like: +88 01703405632, (123) 123-1234, 123-123-1234, +1 415 555 2671, +44 20 7946 0958
                    const phoneRegex = /^(\+\d{1,3}[\s-]?)?\(?\d{3}\)?[\s-]?\d{3}[\s-]?\d{4}$|^(\+\d{1,3}[\s-]?)?\d{10,15}$/;
                    return phoneRegex.test(value);
                }
            },
            title: {
                required
            },
            companyName: {
                required
            },
            companyWebsiteUrl: {
                required,
                url: (value) => {
                    if (!value) return true;
                    const urlPattern = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9][-a-zA-Z0-9]*\.)+[a-zA-Z]{2,}(\/.*)?$/;
                    return urlPattern.test(value);
                }
            },
            selectedIndustry: {
                required
            }
        };
    },
    setup() {
        return { v$: useVuelidate() };
    },
    async mounted() {
        this.userDetails = JSON.parse(localStorage.getItem('pro_marketplaceUser'));
        await this.fetchIndustryOptions();
    },
    methods: {
        async submit() {
            this.submitted = true;
            this.v$.$touch();
            
            if (this.v$.$invalid) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Validation Error',
                    detail: 'Please fill in all required fields correctly',
                    life: 3000,
                });
                return;
            }

            await this.addChannel();
        },

        async addChannel() {
            this.loading = true;
            
            const payload = {
                quickbooksID: this.quickbooksID,
                accountCode: this.accountCode,
                name: this.Name,
                description: this.description,
                channelName: this.Name,
                adminFirstName: this.adminFirstName,
                adminLastName: this.adminLastName,
                adminEmail: this.adminEmail,
                phoneNumber: this.phoneNumber,
                title: this.title,
                companyName: this.companyName,
                companyWebsiteUrl: this.companyWebsiteUrl,
                selectedIndustry: this.selectedIndustry,
            };

            try {
                const userResponse = await this.accountMangementService.addNewUser(payload);
                
                if (userResponse.status == 200) {
                    // Create user account
                    const userCreationPayload = {
                        email: this.adminEmail,
                        account_id: userResponse.data.accountID,
                        user_role_id: USER_ROLE_IDS.CHANNEL,
                        last_name: this.adminLastName,
                        first_name: this.adminFirstName,
                    };
                    
                    await this.userManagementService.addNewUser(userCreationPayload);
                    
                    this.$toast.add({ 
                        severity: 'success', 
                        summary: 'Channel Created', 
                        detail: 'Channel created successfully',
                        life: 3000 
                    });
                    
                    this.resetForm();
                    
                    // Refresh the menu data
                    EventBus.emit('refresh-menu');
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error while creating channel',
                        detail: userResponse.data,
                        life: 3000,
                    });
                }
            } catch (error) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'An error occurred while creating the channel',
                    life: 3000,
                });
            } finally {
                this.loading = false;
            }
        },

        resetForm() {
            this.Name = '';
            this.accountCode = '';
            this.quickbooksID = '';
            this.description = '';
            this.adminFirstName = '';
            this.adminLastName = '';
            this.adminEmail = '';
            this.phoneNumber = '';
            this.title = '';
            this.companyName = '';
            this.companyWebsiteUrl = '';
            this.selectedIndustry = null;
            this.submitted = false;
            this.v$.$reset();
        },

        validateNumberInput(event) {
            const char = String.fromCharCode(event.which);
            if (!/[0-9]/.test(char)) {
                event.preventDefault();
            }
        },

        async fetchIndustryOptions() {
            const optionsSvc = new optionsService();
            try {
                const optionData = await optionsSvc.getOptions();
                
                let industryData = {};
                if (optionData.status === 200 && Array.isArray(optionData.data.data)) {
                    optionData.data.data.forEach(option => {
                        if (option.is_public) {
                            if (!industryData[option.industry_name]) {
                                industryData[option.industry_name] = [];
                            }
                            industryData[option.industry_name].push({
                                specialty: option.specialty_name,
                                id: option.ref_industry_id
                            });
                        }
                    });
                }

                // Remove duplicates
                for (const industry in industryData) {
                    industryData[industry] = this.removeDuplicateSpecialties(industryData[industry]);
                }

                this.industryOptions = this.transformIndustryData(industryData);
            } catch (error) {
                console.error('Error fetching industries:', error);
            }
        },

        removeDuplicateSpecialties(specialties) {
            const uniqueSpecialties = [];
            const seenSpecialties = new Set();

            specialties.forEach(specialty => {
                if (!seenSpecialties.has(specialty.specialty)) {
                    uniqueSpecialties.push(specialty);
                    seenSpecialties.add(specialty.specialty);
                }
            });

            return uniqueSpecialties;
        },

        transformIndustryData(industryData) {
            const industryOptions = [];
            
            for (const industryName in industryData) {
                const specialties = industryData[industryName];
                const items = specialties.map(specialty => ({
                    label: specialty.specialty,
                    value: specialty.id
                }));

                industryOptions.push({
                    label: industryName,
                    items: items
                });
            }

            return industryOptions;
        },

        handleDropdownChange(event) {
            // Handle dropdown change if needed
        }
    }
};
</script>

<style scoped>
:deep(.btn) {
    width: 8rem !important;
}

:deep(.card) {
    margin-top: 1.5rem;
}

.error-msg {
    margin-left: 1.25rem;
    color: red;
    font-size: 1rem;
    font-weight: 400;
}

::v-deep(.p-inputtext),
::v-deep(.p-dropdown) {
    margin-left: 1rem;
    max-width: 30rem;
}

.title {
    font-weight: 700;
    font-family: 'Prompt', sans-serif;
    font-size: 27px;
}

.field-title {
    margin-left: 1rem;
    font-size: 1.2rem;
    font-weight: 400;
    max-width: 30rem;
}

.industry-heading {
    padding: 0.5rem 0;
}

.industryOptionHeader {
    font-weight: 600;
    color: #333;
    padding: 0.25rem 0;
}

.industry-underline {
    margin: 0.25rem 0;
    border: none;
    border-top: 1px solid #ddd;
}

.industryOption {
    padding: 0.25rem 0;
    color: #666;
}
</style>
